<i18n
  src="@/locales/views/agro_exporter/finances/container_incomes/show_export_invoice.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/export_invoice.yml" lang="yaml"></i18n>

<i18n src="@/locales/models/invoice_payment.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_container')"
    :params="{
      agro_exporter_id: agro_exporter_id,
      agro_exporter_process_id: agro_exporter_process_id,
      container_id: container_id || export_invoice.container_id
    }"
  >
  </go-back-link>

  <bread-crumbs :labels="[module_name, agro_exporter_process.name]" />

  <template v-if="load_data_general">
    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>
        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.export_invoice.container") }}
                </dt>
                <dd class="content-data">
                  {{ export_invoice.container.container_code }}
                  <yes-no-label
                    :value="export_invoice.container.export_invoices_paid"
                    yes="Pagado"
                    no="No pagado"
                  />
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.container.customer") }}
                </dt>
                <dd class="content-data">
                  {{ export_invoice.container.customer.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.export_invoice.invoice_code") }}
                </dt>
                <dd class="content-data">
                  {{ export_invoice.invoice_code }}
                  <yes-no-label
                    :value="export_invoice.paid"
                    yes="Pagada"
                    no="No pagada"
                  />
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.export_invoice.invoice_date") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(export_invoice.invoice_date) }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.export_invoice.amount") }}
                </dt>
                <dd class="content-data">
                  {{
                    currencyMoney(
                      export_invoice.amount,
                      export_invoice.currency.symbol
                    )
                  }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.export_invoice.amount_paid") }}
                </dt>
                <dd class="content-data">
                  {{
                    currencyMoney(
                      export_invoice.amount_paid,
                      export_invoice.currency.symbol
                    )
                  }}
                </dd>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <destroy-button
              v-if="!proc_button_destroy"
              :disabled_button="false"
              @destroyEvent="destroyExportInvoice()"
              :label="$t('labels.destroy_button_label')"
              :title="
                $t('labels.destroy_button_title', {
                  invoice_code: export_invoice.invoice_code
                })
              "
              :message="$t('labels.destroy_button_message')"
              :label_confirm="$t('labels.destroy_button_label_confirm')"
            />
            <destroy-button-processing
              v-else
              :label="$t('labels.destroy_button_label')"
            />
            <span class="space-actions"></span>
            <pay-export-invoice-button
              :paid="export_invoice.paid"
              @payExportInvoice="updateExportInvoice"
            ></pay-export-invoice-button>
            <span class="space-actions"></span>
            <edit-button
              @click.prevent="goToEditExportInvoice()"
              :label="$t('labels.edit_button')"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-8 flex flex-row">
      <h1 class="page-title">
        <i class="fa-solid fa-money-check-dollar"></i>
        <span class="space-icon"></span>
        {{ $t("labels.title_invoice_payments") }}
      </h1>
    </div>
    <div class="mt-8 flex flex-row justify-between">
      <div class="panel-plain-label">
        <badge-default
          :label="
            invoice_payments.length +
            ' ' +
            $t('labels.total_number_invoice_payments')
          "
        />
        <span class="space-actions"></span>
        <badge-default
          :label="
            export_invoice.currency.symbol +
            numberWithPrecision(total_amount_paid) +
            ' ' +
            export_invoice.currency.plural_name
          "
        />
      </div>
      <new-button
        @click.prevent="goToNewInvoicePayment()"
        :label="$t('labels.new_invoice_payment_button')"
      />
    </div>

    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.invoice_payment.payment_at") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.invoice_payment.amount") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="invoice_payment in invoice_payments"
                  :key="invoice_payment.id"
                >
                  <td class="table-cell">
                    {{ dateFormatter(invoice_payment.payment_at) }}
                  </td>
                  <td class="table-cell">
                    {{
                      currencyMoney(
                        invoice_payment.amount,
                        export_invoice.currency.symbol
                      )
                    }}
                  </td>
                  <td class="table-cell-action">
                    <destroy-button
                      v-if="!invoice_payment.proc_button_destroy"
                      :disabled_button="false"
                      @destroyEvent="destroyInvoicePayment(invoice_payment)"
                      :label="$t('labels.destroy_button_label')"
                      :title="$t('labels.destroy_invoice_payment_button_title')"
                      :message="
                        $t('labels.destroy_invoice_payment_button_message')
                      "
                      :label_confirm="$t('labels.destroy_button_label_confirm')"
                    />
                    <destroy-button-processing
                      v-else
                      :label="$t('labels.destroy_button_label')"
                    />
                    <span class="space-actions"></span>
                    <edit-button
                      :label="$t('labels.edit_button')"
                      @click="goToEditInvoicePayment(invoice_payment)"
                    >
                    </edit-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/finances/container_incomes/show_export_invoice.js";
import ManageExportInvoiceRequester from "@/views/agro_exporter/requesters/finances/container_incomes/manage_export_invoice.js";
import ManageInvoicePaymentRequester from "@/views/agro_exporter/requesters/finances/container_incomes/manage_invoice_payment.js";
import PayExportInvoiceButton from "@/components/views/agro_exporter/finances/container_incomes/PayExportInvoiceButton.vue";
export default {
  components: { PayExportInvoiceButton },
  name: "AEFinancesContainerIncomesShowExportInvoice",
  props: {
    agro_exporter_process_id: { required: true },
    agro_exporter_id: { required: true },
    export_invoice_id: { required: true },
    container_id: {}
  },
  data() {
    return {
      load_data_general: false,
      proc_save_button: false,
      proc_button_destroy: false,
      agro_exporter_process: {},
      export_invoice: {},
      invoice_payments: []
    };
  },
  computed: {
    total_amount_paid: function () {
      return this.invoice_payments.reduce(
        (sum, payment) => sum + payment.amount,
        0
      );
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchExportInvoice();
      await this.fetchInvoicePayments();
      this.load_data_general = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchExportInvoice: async function () {
      let response = await Requester.fetchExportInvoice(
        this.agro_exporter_id,
        this.export_invoice_id
      );
      this.export_invoice = response.data;
    },
    fetchInvoicePayments: async function () {
      let response = await Requester.fetchInvoicePayments(
        this.agro_exporter_id,
        this.export_invoice_id
      );
      this.invoice_payments = response.data;
      this.invoice_payments.forEach(invoice_payment => {
        invoice_payment["proc_button_destroy"] = false;
      });
    },
    updateExportInvoice: async function () {
      this.proc_save_button = true;
      try {
        let response = await ManageExportInvoiceRequester.update(
          this.agro_exporter_id,
          this.export_invoice_id,
          {
            paid: !this.export_invoice.paid
          }
        );
        let export_invoice_update = response.data.export_invoice;
        this.export_invoice.paid = export_invoice_update.paid;
        this.export_invoice.amount_paid = export_invoice_update.amount_paid;
        this.registerSuccessNotification({
          title: response.data.success_message
        });
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_save_button = false;
    },
    destroyExportInvoice: async function () {
      this.proc_button_destroy = true;
      try {
        let response = await ManageExportInvoiceRequester.destroy(
          this.agro_exporter_id,
          this.export_invoice_id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.goToShowContainer();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      this.proc_button_destroy = false;
    },
    destroyInvoicePayment: async function (invoice_payment) {
      invoice_payment.proc_button_destroy = true;
      try {
        let response = await ManageInvoicePaymentRequester.destroy(
          this.agro_exporter_id,
          invoice_payment.id
        );
        this.registerSuccessNotification({
          title: response.data.success_message
        });
        this.invoice_payments.splice(
          this.invoice_payments.indexOf(invoice_payment),
          1
        );
        this.export_invoice.amount_paid = this.total_amount_paid;
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields
          });
        }
      }
      invoice_payment.proc_button_destroy = false;
    },
    goToEditExportInvoice: function () {
      this.$router.push({
        name: this.routeName("edit_export_invoice"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    },
    goToNewInvoicePayment: function () {
      this.$router.push({
        name: this.routeName("new_invoice_payment"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          export_invoice_id: this.export_invoice_id
        }
      });
    },
    goToEditInvoicePayment: function (invoice_payment) {
      this.$router.push({
        name: this.routeName("edit_invoice_payment"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          invoice_payment_id: invoice_payment.id
        }
      });
    },
    goToShowContainer: function () {
      this.$router.push({
        name: this.routeName("show_container"),
        params: {
          agro_exporter_id: this.agro_exporter_id,
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.loadData())
    );
  }
};
</script>
